import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RapportIncidentAccidentMateriel } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-materiel-select',
  templateUrl: './rapport-incident-materiel-select.component.html',
  styleUrls: ['./rapport-incident-materiel-select.component.css']
})
export class RapportIncidentMaterielSelectComponent implements OnInit {
  @Input() public id: number;
  @Output() idChange = new EventEmitter<number>();
  @Input() width: number;
  @Input() cell: any;

  @Input() widthPopUp: number = 250;

  @Input() disabled: boolean = false;
  
  materiels = [];
  
  constructor(private translate: TranslateService) {
    for (var t in RapportIncidentAccidentMateriel) {
      let value = parseInt(t, 10);
      var isValueProperty = (value >= 0);
      if (isValueProperty) {
        this.materiels.push({ id: value, name: this.translate.instant('Rapports.RapportsIncidents.Materiels.' + RapportIncidentAccidentMateriel[t])});
      }
    } 
  }

  ngOnInit(): void {}

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  } 

  onOpened() {
    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }

}
